<template>
  <div class="h-full" v-if="screen === 'loading'">
    <div class="flex h-full w-full items-center justify-center">
      <i v-html="$icons.spinner_lg" class="animate-spin"></i>
    </div>
  </div>
  <payer-data-component
    v-else-if="screen === 'payment'"
    :product="product"
    :planChangeType="planChangeType"
  />
  <user-data-component v-else-if="screen === 'user-data'" @registered="goToPayment" />
</template>

<script>
import { mapActions } from "vuex";
import payerDataComponent from "./payer-data.component.vue";
import UserDataComponent from "./user-data.component.vue";

export default {
  components: {
    payerDataComponent,
    UserDataComponent,
  },

  props: {
    planChangeType: String,
  },

  data() {
    return {
      type: this.$route.query.type,
      screen: "loading",
      // planChangeType: "downgrade",
      product: {
        name: null,
        type: null,
        period: null,
        price: null,
      },
    };
  },

  methods: {
    ...mapActions({ setUserConfig: "config/setUserConfig" }),
    goToPayment() {
      this.getInfo();
      this.screen = "payment";
    },
    getInfo() {
      const params = {
        plans: {
          invoice_type: "PLAN",
          plan_id: this.$route.query.plan_id,
        },
        extensions: {
          invoice_type: "EXTENSION",
          extension_id: this.$route.query.extension_id,
        },
        products: {
          invoice_type: "PRODUCT",
          extension_id: this.$route.query.product_id,
        },
      };
      this.$api
        .get(this.$endpoint.GET_INVOICE_INFO, {
          params: params[this.type],
        })
        .then((res) => {
          const data = res.data;
          if (data.plan_change_type) {
            this.product = data;
            this.screen = "payment";
          } else {
            switch (this.type) {
              case "plans":
                this.product = {
                  name: data.plan_name,
                  type: "plan",
                  period: data.plan_days === 30 ? "month" : "year",
                  price: data.plan_price,
                };
                break;
              case "extensions":
                this.product = {
                  name: data.extension_name,
                  type: "extension",
                  period: "month",
                  price: data.extension_price,
                };
                break;
              case "products":
                this.product = {
                  name: data.product_name,
                  type: "product",
                  period: "month",
                  price: data.product_price,
                };
                break;
            }
            this.screen = "payment";
            // this.screen = "user-data";
          }
        })
        .catch((err) => {
          console.error(err);
          if (
            !err.data.msg ||
            err.data.msg === "dados de preço não encontrados para a extensão"
          ) {
            this.$swal(
              "Extensão adicionada",
              'Você pode encontrar a extensão adicionada clicando no ícone de seta ao lado de "Parceiros" no menu lateral.',
              "success"
            ).then(() => {
              this.$api
                .get(this.$endpoint.USER_CONFIGS)
                .then((res) => {
                  this.setUserConfig(res.data);
                })
                .finally(() => {
                  this.$router.push({ name: "Dashboard" });
                });
            });
          } else {
            this.$swal("Erro", err.data.msg, "error").then(() => {
              if (err.data.action && err.data.action === "ADDRESS_SCREEN") {
                this.screen = "user-data";
              } else {
                this.$swal(
                  "Erro",
                  err.data.msg.charAt(0) + err.data.msg.slice(1),
                  "error"
                );
              }
            });
          }
        });
    },
  },
  created() {
    this.getInfo();
  },
};
</script>

<style></style>
